import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { CAREERS_INTRO } from "../../../data/careers";

export const CareersHero = () => {
  return (
    <section
      data-testid="careers-hero"
      className="relative pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden"
    >
      <div className="absolute inset-0 grid-lines opacity-60 pointer-events-none" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-3 mb-10 md:mb-16"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-amber-accent inline-block" />
          <span className="overline text-amber-accent">{CAREERS_INTRO.overline}</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-black tracking-tight leading-[0.95] text-ink text-balance max-w-5xl"
          style={{ fontSize: "clamp(2.5rem, 7vw, 6rem)" }}
        >
          {CAREERS_INTRO.headline[0]}
          <br />
          {CAREERS_INTRO.headline[1].split(" ").map((w, i) =>
            w.toLowerCase() === "tomorrow" ? (
              <span key={i} className="italic font-light text-amber-accent">
                {w}{" "}
              </span>
            ) : (
              <span key={i}>{w} </span>
            ),
          )}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-8 md:mt-10 max-w-2xl text-ink-soft text-base md:text-lg leading-relaxed"
        >
          {CAREERS_INTRO.body}
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 1 }}
          className="mt-14 md:mt-20 flex items-center gap-3 text-ink-soft"
        >
          <ArrowDown className="w-3.5 h-3.5 animate-bounce" />
          <a
            href="#open-roles"
            data-testid="hero-scroll-open-roles"
            className="font-mono text-[11px] tracking-[0.25em] uppercase hover:text-ink transition-colors"
          >
            View open roles
          </a>
        </motion.div>
      </div>
    </section>
  );
};
